export default {
    settings: 'Settings',
    overview: 'Overview',
    incidents: 'Incidents',
    insights: 'Insights',
    workflows: 'Workflows',
    members: 'Members',
    analytics: 'Analytics Reports',
    'custom-tables': 'Custom table',
    'export-history': 'Export history',
    'import-history': 'Import history',
}
